import { motion } from "framer-motion";
import Seo from "../components/Seo";
import LiveThreatFeed from "../components/LiveThreatFeed";
import DigitalRiskSection from "../components/DigitalRiskSection";
import ResourcesSection from "../components/ResourcesSection";
import { BOOK_DEMO_URL } from "../lib/constants";

export default function Dri() {
  return (
    <>
      <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute top-[-10%] left-[-10%] w-[800px] h-[800px] rounded-full bg-secondary opacity-[0.03] blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] rounded-full bg-primary opacity-[0.02] blur-[100px]" />
      </div>

      <main className="pb-section-gap max-w-container-max mx-auto px-gutter md:px-card-padding">
        <Seo
          title="Digital Risk Intelligence"
          description="Your brand and your people are attacked outside your firewall too. Cybermon watches the dark web, phishing infrastructure, and social platforms so a leaked credential doesn't become a breach."
          path="/dri"
        />

        <section className="pt-16 md:pt-[60px] mb-section-gap flex flex-col md:flex-row gap-12 items-center">
          <div className="flex-1 flex flex-col gap-stack-lg">
            <span className="font-eyebrow text-eyebrow text-secondary uppercase tracking-widest">
              MODULE 2
            </span>
            <motion.h1
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="font-display-hero-mobile md:font-display-hero text-display-hero-mobile md:text-display-hero text-on-surface dark:text-surface-bright"
            >
              Digital Risk Intelligence —<br />Know before it's exploited.
            </motion.h1>
            <p className="font-body-lg text-body-lg text-on-surface-variant dark:text-surface-variant max-w-2xl">
              Your brand and your people are attacked outside your firewall too. Cybermon watches
              the dark web, phishing infrastructure, and social platforms so a leaked credential
              doesn't become a breach.
            </p>
            <div className="pt-4 flex gap-4">
              <a
                href={BOOK_DEMO_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-secondary text-on-secondary font-headline-card text-sm px-6 py-3 rounded-lg hover:scale-105 transition-transform shadow-md"
              >
                Book a Demo
              </a>
              <a
                href="#modules"
                className="bg-surface-card-light dark:bg-surface-card-dark border border-glass text-on-surface dark:text-surface-bright font-headline-card text-sm px-6 py-3 rounded-lg hover:-translate-y-1 transition-transform backdrop-blur-md"
              >
                Explore Features
              </a>
            </div>
          </div>

          <LiveThreatFeed />
        </section>

        <div id="modules">
          <DigitalRiskSection />
        </div>

        <ResourcesSection
          moduleKey="dri"
          eyebrowColor="text-secondary"
          heading="Take the case to your team"
          subhead="The one-page flyer for a quick share, or the full coverage document for the follow-up conversation."
        />

        <section className="bg-surface-card-light dark:bg-surface-card-dark border border-glass rounded-3xl p-card-padding text-center backdrop-blur-xl shadow-lg relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-secondary/5 to-transparent pointer-events-none" />
          <div className="max-w-2xl mx-auto relative z-10 flex flex-col items-center">
            <h2 className="font-headline-section text-headline-section text-on-surface dark:text-surface-bright mb-4">
              Know before it's exploited.
            </h2>
            <p className="font-body-md text-body-md text-on-surface-variant dark:text-surface-variant mb-8">
              Stop external threats outside the firewall from turning into a critical breach
              inside your network.
            </p>
            <a
              href={BOOK_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-secondary text-on-secondary font-headline-card text-base px-8 py-4 rounded-lg hover:scale-105 transition-transform shadow-md"
            >
              Book a Demo
            </a>
          </div>
        </section>
      </main>
    </>
  );
}
